import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const brazeTemplate = {
	id: 'braze',
	guid: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
	name: 'Braze',
	category: TEMPLATE_CATEGORIES.CUSTOMER_ENGAGEMENT,
	popularity: 'Popular',
	color: '#ff6b35',
	icon: 'mdi-fire',
	description: 'Connect to Braze customer engagement platform for marketing campaigns.',
	features: ['API Key Auth', 'User Tracking', 'Push Notifications', 'Email Campaigns'],
	configFields: [
		{ name: 'apiKey', label: 'API Key', type: 'password', required: true, placeholder: 'Enter your Braze API key' },
		{ name: 'instanceUrl', label: 'Instance URL', type: 'text', required: true, placeholder: 'https://rest.iad-01.braze.com' }
	],
	endpoints: [

		{
			name: 'Create User Alias',
			url: '{instance_url}/users/alias/new',
			method: 'POST',
			description: 'Use this endpoint to add new user aliases for existing identified users, or to create new unidentified users.',
			cassieObjectID: -3,
			incrementField: 'syrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'SyrenisID', filter: '' },
				{ name: 'Email1', filter: '' }
			],
			requestBody: '{ "user_aliases": [{ "external_id": "[PLACEHOLDER_SYRENISID]", "email": "[PLACEHOLDER_EMAIL1]" }] }',
			headers: [{ Name: 'Authorization', value:	'Bearer [APIKEY]' }],
			successResponses: [{ code: 201, message: 'success' }]
		},

		{
			name: 'Set Subscription',
			url: '{instance_url}/v2/subscription/status/set',
			method: 'POST',
			description: 'Update user subscription group status in Braze',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ChannelID', filter: '' },
				{ name: 'Email1', filter: '' },
				{ name: 'PreferenceID', filter: '' },
				{ name: 'ConsentValue', filter: '' }
			],
			requestBody: '{ "subscription_groups": [{ "subscription_group_id": "[PLACEHOLDER_CHANNELID]", "subscription_state": "[PLACEHOLDER_CONSENTVALUE]", "emails": ["[PLACEHOLDER_EMAIL1]"] }] }',
			headers: [{ Name: 'Authorization', value:	'Bearer [APIKEY]' }],
			successResponses: [{ code: 201, message: 'success' }]
		}

	],
	defaults: {
		endpointAddress: 'https://rest.iad-01.braze.com',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'Braze customer engagement platform integration for personalized marketing campaigns and user tracking.'
	}
}
